import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  template: `
    <div
      class="fx-col fx-align-center fx-justify-center s-full overflow-hidden"
      data-testid="spinner">
      <ion-spinner
        class="py-15"
        color="accent"
        name="lines"></ion-spinner>
        <div
          *ngIf="message"
          class="mb-4 text-grey-400 h5 text-center mx-3">
          {{ message }}
        </div>
    </div>
  `,
  styles: [],
})
export class SpinnerComponent {
  @Input() message?: string;
}
